/**
 * Client-side client-view analytics event buffer.
 */
const STORAGE_KEY = "midpoint_cv_local_analytics_events";
const MAX_EVENTS = 500;

function readEvents() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeEvents(events) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events.slice(-MAX_EVENTS)));
  } catch {
    // localStorage blocked — silent fail
  }
}

export function appendClientViewLocalAnalyticsEvent(event) {
  const events = readEvents();
  events.push(event);
  writeEvents(events);
  return event;
}

export function listClientViewLocalAnalyticsEvents({ limit = MAX_EVENTS } = {}) {
  const events = readEvents();
  return events.slice(-limit);
}

export function clearClientViewLocalAnalyticsEvents() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
